import {citiesReducer} from './cities/reducer';
import {Action, ActionReducerMap} from '@ngrx/store';
import {SET_APP_CONTEXT} from './constants';
import {AppContext} from './AppContext';
import {serviceReducer} from './service/reducer';
import {categoriesReducer} from './categories/reducer';
import {userReducer} from './user/reducer';
import {AppState} from './AppState';
import {serviceUiReducer} from './serviceUi/reducer';
import {routerReducer} from '@ngrx/router-store';
import {showHeader} from './showHeader/reducer';

export const reducers: ActionReducerMap<AppState> = {
  cities: citiesReducer,
  service: serviceReducer,
  categories: categoriesReducer,
  user: userReducer,
  serviceUi: serviceUiReducer,
  routerReducer: routerReducer as any,
  showHeader,
};

export class SetAppContextAction implements Action {
  readonly type = SET_APP_CONTEXT;

  constructor(public payload: AppContext) {}
}

export class DummyAction implements Action {
  readonly type = 'DUMMY';
}
